import { type FieldName, useFormContext, type FieldValues } from "react-hook-form";

import { retrieveFormError } from "@/utils/formUtils.ts";

export const useFormError = <T extends FieldValues>(name: FieldName<T>) => {
  const formContext = useFormContext<T>();
  return retrieveFormError<T>(formContext.formState.errors[name]);
};
